import React, { useState, useEffect } from 'react';
import { Dialog, DialogContent, DialogActions, Button } from '@mui/material';
import { Snackbar } from '@mui/material';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import CableCantonEditingDialog from '../DialogEditingType/CableCantonEditingDialog';
import { CONST_AIR, CONST_AIR_INTERHOUSE, CONST_AIR_PILLAR, CONST_BASEMENT, CONST_FACADE, CONST_LOFT, ROLE_ADMIN, ROLE_ENGINNER, ROLE_MASTER, ROLE_SENIOR_MASTER } from '../../../Constants/ConstantsOptics';
import ModalDescriptionComponentSpecifically from '../../../Modal/ModalDescriptionComponentSpecifically';
import { CABLE, CABLE_FLAG, CONST_SUBWAY } from '../../../Constants/ConstantsOptics';
import DialogCablePdf from '../../DialogPdf/DialogCablePdf';
import { TerritoryLabel } from '../TerritoryLabel ';
import { fetchCableConnectionCount } from '../CountFile/ConnectionCount';
import { fetchCableFileCount } from '../CountFile/FileCount';
import ModalRouteCableMapDescription from '../../../Modal/ModalRouteCableMapDescription';
import SwapCallsRoundedIcon from '@mui/icons-material/SwapCallsRounded';

const CableCantonDialog = ({ open, onClose, content, snackbarOpen, snackbarMessage, snackbarClass,
  handleCloseSnackbar, copyToClipboard, role, user, changeLinkEditing, cantonRefresh,
  groupedCoordinatesWithColorTypeAndWidth, wellData, fobLocationData, couplingLocationData, ponBoxLocationData,
  pillarData, changeLinkEditingMarker, cantonCablaByIdRefresh, territoryList}) => {
  
  const [openModalEditing, setOpenModalEditing] = useState(false);
  const [openModalDescription, setOpenModalDescription] = useState(false);
  const [openModalPdf, setOpenModalPdf] = useState(false);
  const [openModalRout, setOpenModalRout] = useState(false);
  const [fileCount, setFileCount] = useState(0);
  const [connectionCount, setConnectionCount] = useState(0);

  const openModalPdfFile = () => {
    if(fileCount != 0){
      setOpenModalPdf(true);
    }
  }; 

  const openModalRoute = () => {
    setOpenModalRout(true);
  }; 

  const openModalEditingContent = () => {
     setOpenModalEditing(true);
  };

  const openModalDescriptionComponents = () => {
    if(connectionCount != 0){
       setOpenModalDescription(true);
    }
  }; 

  useEffect(() => {
    const updateFileCount = async () => {  
      const count = await fetchCableFileCount(content.id);
      if (count !== null) {
        setFileCount(count); 
      }
    };
    updateFileCount();
  });

  useEffect(() => {
    const updateConnectionCount = async () => {  
      const count = await fetchCableConnectionCount(content.id);
      if (count !== null) {
        setConnectionCount(count); 
      }
    };
    updateConnectionCount();
  });

  return (
    <Dialog open={open} className="dialogStyle">    
    <DialogContent>
    <img src='./cable.png' width='30' height='30' style={{marginRight: "5px"}}/>
    <label style={{ color: '#dfab01', fontSize: '20px', fontFamily:'unset', textShadow: '2px 2px 4px rgb(61, 61, 61)'}}>Кабель</label>
      <hr className='horizontalLineDialog'/>
      <label style={{ color: '#292929', fontWeight: 'bold',textShadow: '2px 2px 4px #4e4e4e' }}>ID: <span style={{ color: '#bebebe', textShadow: '2px 2px 4px rgb(61, 61, 61)' }}>{content.id}</span></label>
      <Button 
          style={{marginLeft: '10px', minWidth: '25px', width: '25px', minHeight: '25px', height: '25px' }}
          onClick={() => { copyToClipboard(content.id, "кабель"); }}>
          <FileCopyIcon style={{ color: '#e4c253'}}/>
        </Button>
       <br/>
     <TerritoryLabel  content={content} />
      <hr className='horizontalLineDialog2'/>
        <label style={{ color: '#292929', fontWeight: 'bold' }}>
          Активна: 
          <span style={{ 
            color: content.activity === 1 ? '#78cf8b' : '#de858e', 
            fontWeight: 'bold',
            textShadow: '2px 2px 4px rgb(61, 61, 61)',
            marginLeft: '8px' 
          }}>
            {content.activity === 1 ? 'Да' : 'Нет'}
          </span>
        </label>
        <br/>
        <label style={{ color: '#292929', fontWeight: 'bold' }}>
           Признак: 
           <span style={{ color: content.ether === 1 || content.pon === 1 || content.ktv === 1 ? '#bdab6f' : '#de858e', textShadow: '2px 2px 4px rgb(61, 61, 61)' }}>
             {[
                content.pon === 1 && ' PON',
                content.ktv === 1 && ' KTV',
                content.ether === 1 && ' Ethernet'
             ]
              .filter(Boolean) 
             .join(', ') || ' Нет'}
           </span>
        </label>
        <br />
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Кабель: <span style={{ color: '#bebebe',fontWeight: 'normal', textShadow: '2px 2px 4px rgb(61, 61, 61)'}}>{content.cableName}</span></label>
      <br/>
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Количество волокон: <span style={{ color: '#bebebe',fontWeight: 'normal', textShadow: '2px 2px 4px rgb(61, 61, 61)' }}>{content.cableFiberQuantity}</span></label>
      <br/>
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Тип: <span style={{ color: '#bebebe',fontWeight: 'normal', textShadow: '2px 2px 4px rgb(61, 61, 61)' }}>{content.cableTypeType}</span></label>
      <br/>
      {content.cableTypeType === CONST_SUBWAY && (
          <>
           <hr className='horizontalLineDialog2'/>
            <label style={{ color: '#292929', fontWeight: 'bold' }}>Номер договора: <span style={{ color: '#bebebe', fontWeight: 'normal', textShadow: '2px 2px 4px rgb(61, 61, 61)' }}>{content.contractNumber}</span></label>
            <br />
            <label style={{ color: '#292929', fontWeight: 'bold' }}>Номер кабеля: <span style={{ color: '#bebebe', fontWeight: 'normal', textShadow: '2px 2px 4px rgb(61, 61, 61)' }}>{content.cableNumber}</span></label>
            <br/>            
            <label style={{ color: '#292929', fontWeight: 'bold' }}>Длина (акт приема): <span style={{ color: '#bebebe', fontWeight: 'normal', textShadow: '2px 2px 4px rgb(61, 61, 61)' }}>{content.lengthAct} м.</span></label>
            <br />
          </>
        )}
       {[CONST_AIR_INTERHOUSE, CONST_AIR_PILLAR, CONST_BASEMENT, CONST_FACADE, CONST_LOFT].includes(content.cableTypeType) && (
          <>
           <hr className='horizontalLineDialog2'/>
                 
            <label style={{ color: '#292929', fontWeight: 'bold' }}>Длина (факт): <span style={{ color: '#bebebe', fontWeight: 'normal', textShadow: '2px 2px 4px rgb(61, 61, 61)' }}> {content.lengthAct || 0} м.</span></label>
            <br />
          </>
        )}
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Длина кабеля: <span style={{ color: '#bebebe',fontWeight: 'normal', textShadow: '2px 2px 4px rgb(61, 61, 61)' }}>{content.lengthCable} м.</span></label>
      <hr className='horizontalLineDialog2'/>
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Принадлежность к узлам: <span style={{ color: '#bebebe',fontWeight: 'normal', textShadow: '2px 2px 4px rgb(61, 61, 61)' }}>{content.rankCableName}</span></label>
      <br/>
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Подрядчик: <span style={{ color: '#bebebe',fontWeight: 'normal', textShadow: '2px 2px 4px rgb(61, 61, 61)' }}>{content.contractorName}</span></label>
      <br/>
      {content.cableTypeType === CONST_SUBWAY && (
          <>
           <hr className='horizontalLineDialog2'/>
            <label style={{ color: '#292929', fontWeight: 'bold' }}>Инженер: <span style={{ color: '#bebebe', fontWeight: 'normal', textShadow: '2px 2px 4px rgb(61, 61, 61)' }}>{content.engineer}</span></label>
            <br />
          </>
        )}
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Внес: <span style={{ color: '#bebebe',fontWeight: 'normal', textShadow: '2px 2px 4px rgb(61, 61, 61)' }}>{content.authorId}</span></label>
      <br/>
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Дата добавления: <span style={{ color: '#bebebe',fontWeight: 'normal', textShadow: '2px 2px 4px rgb(61, 61, 61)' }}> {new Date(content.createDate).toISOString().slice(0, 19).replace("T", " ")}</span></label>
      <br/>
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Комментарий: <span style={{ color: '#bebebe',fontWeight: 'normal', textShadow: '2px 2px 4px rgb(61, 61, 61)' }}>{content.description}</span></label>
      <hr className='horizontalLineDialog2'/>

      <button onClick={openModalDescriptionComponents} class='buttonIsConnectionDialog' style={{textShadow: '2px 2px 4px rgb(61, 61, 61)'}}>
        Связи
          <span className={`countCircle ${connectionCount > 0 ? 'green' : 'red'}`}>
            {connectionCount > 0 ? connectionCount : 'нет'}
          </span>
        </button>

      <hr className="horizontalLineDialog2" style={{marginTop: "10px"}}/> 
      {/* {content.cableTypeType === CONST_SUBWAY && (
          <> */}
            <button onClick={openModalPdfFile} className='buttonIsConnectionDialog' style={{textShadow: '2px 2px 4px rgb(61, 61, 61)'}}>
                Просмотр файлов
                <span className={`countCircle ${fileCount > 0 ? 'green' : 'red'}`}>
                    {fileCount > 0 ? fileCount : 'нет'}
                  </span>
            </button>   
            
            <hr className='horizontalLineDialog'/>
          {/* </>
        )} */}
              <button onClick={openModalRoute} className='buttonIsConnectionDialog' style={{textShadow: '2px 2px 4px rgb(61, 61, 61)'}}>
                  Маршрут
                  <SwapCallsRoundedIcon style={{ marginRight: '5px' }} />
              </button>   
              
              <hr className='horizontalLineDialog'/>
           
    </DialogContent>

    <DialogActions>
    {/* {((user === content.authorId && (role.role === ROLE_ENGINNER || role.role === ROLE_SENIOR_MASTER )) || role.role === ROLE_ADMIN) &&
      ![1, 2, 4].includes(content.rankCableId) && ( */}
      {(
        (
          (user === content.authorId &&
            (role.role === ROLE_ENGINNER || role.role === ROLE_MASTER)
          ) ||
          role.role === ROLE_ADMIN ||
          (role.role === ROLE_ENGINNER  && territoryList.includes(content.canton))
        ) &&
        ![1, 2, 4].includes(content.rankCableId)
      ) && (
      <Button onClick={openModalEditingContent} class='buttonIsEditDialog'>
          Редактировать
        </Button>
         )}
      <Button onClick={onClose} class='buttonIsHideDrawer23'>
        Закрыть
      </Button>
    </DialogActions>

     {/* Snackbar */}
     <Snackbar
         anchorOrigin={{
         vertical: 'bottom',
         horizontal: 'left',
         }}
         open={snackbarOpen}
         autoHideDuration={4000}
         onClose={handleCloseSnackbar}
         message={snackbarMessage}
         ContentProps={{
          style: {
            color: snackbarClass === 'snackbarOk' ? '#ffda62' : '#202020'
          }
        }}
      />

        {/* Описание связей компонентов*/}
        <ModalDescriptionComponentSpecifically
          open={openModalDescription}
          onClose={() => setOpenModalDescription(false)}
          id={content.id}
          type={CABLE}
          flag={CABLE_FLAG}
          groupedCoordinatesWithColorTypeAndWidth={groupedCoordinatesWithColorTypeAndWidth}
          wellData={wellData}
          fobLocationData={fobLocationData}
          couplingLocationData={couplingLocationData}
          ponBoxLocationData={ponBoxLocationData}
          pillarData={pillarData}
        />

      {/* Modal редактирование CableCanton*/}
      <CableCantonEditingDialog
        open={openModalEditing}
        onClose={() => setOpenModalEditing(false)}
        onClose2={onClose}
        content={content}
        user={user}
        changeLinkEditing={changeLinkEditing}
        cantonRefresh={cantonRefresh}
        groupedCoordinatesWithColorTypeAndWidth={groupedCoordinatesWithColorTypeAndWidth}
        wellData={wellData}
        fobLocationData={fobLocationData}
        couplingLocationData={couplingLocationData}
        ponBoxLocationData={ponBoxLocationData}
        pillarData={pillarData}
        changeLinkEditingMarker={changeLinkEditingMarker}
        role={role}
        cantonCablaByIdRefresh={cantonCablaByIdRefresh}
      /> 

       {/* Modal PDF*/}
       <DialogCablePdf
          open={openModalPdf}
          onClose={() => setOpenModalPdf(false)}
          id={content.id} 
      /> 

       {/* Маршрут кабеля*/}
       <ModalRouteCableMapDescription
        open={openModalRout}
        onClose={() => setOpenModalRout(false)}
        cableId={content.id}
      />     
   </Dialog>
  );
}

export default CableCantonDialog;